/* eslint-disable react/require-default-props */
import { HTMLProps, ReactNode } from 'react';
import cx from 'classnames';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';

import styles from './Switch.module.scss';

export type SwitchVariant = 'solid' | 'outline';

type SwitchProps = Pick<HTMLProps<HTMLDivElement>, 'className'> &
  Partial<Pick<ReactSwitchProps, 'checked' | 'disabled' | 'onChange'>> & {
    variant?: SwitchVariant;
    icon?: ReactNode;
    title?: string;
    badge?: string;
    onClick?(): void;
  };

const Switch = ({
  variant = 'solid',
  icon,
  title,
  checked = false,
  disabled = false,
  className,
  badge,
  onChange = () => {},
  onClick
}: SwitchProps) => (
  <div className={cx(styles.container, className)}>
    <div className={styles.text}>
      {icon}
      {title && <span>{title}</span>}
    </div>
    <button type="button" className={styles.toggle} onClick={onClick}>
      {badge && <span className={styles.badge}>{badge}</span>}

      <ReactSwitch
        className={cx(styles.container, {
          [styles[`variant--${variant}`]]: variant,
          [styles['status--off']]: !checked,
          [styles['status--on']]: checked
        })}
        checkedIcon={false}
        uncheckedIcon={false}
        height={31}
        width={51}
        handleDiameter={27}
        boxShadow="0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06)"
        activeBoxShadow="0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06)"
        {...{ checked, disabled, onChange }}
      />
    </button>
  </div>
);

export default Switch;
